import React, { useEffect, useState, useContext } from 'react';
import { UserOrderContext } from 'context/context';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { getAndCheck, getLength, getValueOrDefaultObject } from 'common/utilities/utils';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { useSelector } from 'react-redux';
import {
  checkIfAnyModifierEdited,
  getSubHeaderDataL2,
  checkExcludedModGItem,
} from 'organisms/MenuPDPPage/AU/Utilities/MenuPDPUtils';
import ProductCustomizeToppingComp, {
  getRenderQuantityModifier,
  getRenderCheckBox,
} from 'organisms/ProductListingCustomizationComponent/Presentation/ProductCustomizeToppingComponent';
import { UPDATED_TEXT } from 'common/constants/SharedConstants';
import PRODUCT_CUSTOM_CONSTANTS from 'organisms/ProductListingCustomizationComponent/Constants/CustomizationConstants';
/**
 *  CustomizationAccordionComp Component
 * @param {*} props - Object
 */
export const preventFeature = event => {
  event?.stopPropagation();
  event?.preventDefault();
};

export const toggleAccordion = (groupListItems, event, id, setGroupListItems, preventFeature) => {
  event && preventFeature();
  let mockGroupList = groupListItems.length ? JSON.parse(JSON.stringify(groupListItems)) : [];
  mockGroupList.map((grpitem, idx) => {
    if (grpitem.id === id) {
      grpitem.expanded = !grpitem.expanded;
    }
    return grpitem;
  });
  setGroupListItems([...mockGroupList]);
};

export const updateGroupList = (list, accordionDefaultOpen, pdpItemUpsizeId) => {
  let mockGroupList = list.length ? list : [];
  return mockGroupList?.map((grpitem, idx) => {
    if (getAndCheck(idx === 0, accordionDefaultOpen)) {
      grpitem.expanded = true;
    } else {
      grpitem.expanded = false;
      let modifierArr = grpitem.modifiers.map(item => ({ ...item, productId: pdpItemUpsizeId }));
      grpitem.modifiers = modifierArr;
    }
    return grpitem;
  });
};

export const isUpdatedCheck = (modgrpId, modGroupIdsUpdated, pdpPayloadData) => {
  let x = false;
  if (modGroupIdsUpdated?.length) {
    let uniqueItems = [...new Set(modGroupIdsUpdated)];
    if (uniqueItems.includes(modgrpId)) {
      x = true;
    }
  }
  return x || checkIfAnyModifierEdited(modgrpId, pdpPayloadData);
};

export const setGroupList = (grouplist, setGroupListItems, accordionDefaultOpen, pdpItemUpsizeId) => {
  let mockGroupList = updateGroupList(JSON.parse(JSON.stringify(grouplist)), accordionDefaultOpen, pdpItemUpsizeId);
  setGroupListItems([...mockGroupList]);
};

export const toShowRecipeSuffix = (modifiers, localized, modGMax, additionalProperties) => {
  return localized && getRenderCheckBox(modifiers, additionalProperties, modGMax);
};

export const toShowMaxTag = (showMaxBadge, localized, additionalProperties) => {
  const renderQtyModifier = getRenderQuantityModifier(additionalProperties);
  return showMaxBadge && renderQtyModifier && localized;
};

const CustomizationAccordionComp = props => {
  const {
    grouplist = [],
    getSelectedModifiers,
    selectedModifiers,
    source = '',
    accordionDefaultOpen,
    isModal,
    isStoreClosed,
    catalog,
    localized = true,
  } = props;
  const { PDP, HASH_SYMBOL } = MENU_PDP_PAGE_CONSTANTS;
  const { MAX_TAG } = PRODUCT_CUSTOM_CONSTANTS;
  const [groupListItems, setGroupListItems] = useState([]);
  const cartReducer = useSelector(data => data.cartReducer);
  const [selectedValue, setSelectedValue] = useState([]);
  const { componentOptions, currencyConversionFactor, currencySymbol } = useSelector(data => data.tenantReducer);
  const {
    web: {
      pdp: { deltaPriceInAccordion, showMaxBadge },
    },
  } = componentOptions;
  const { isItemAdded = false } = getValueOrDefaultObject(cartReducer);
  const tenantReducer = useSelector(data => data.tenantReducer);
  // expandType can be `all` or `single`, default is `all`
  const { userOrderState } = useContext(UserOrderContext);
  const {
    pdpScreenCommons: { currentAccordian },
    pdpPayloadData,
    pdpItemUpsizeId,
  } = userOrderState;
  useEffect(() => {
    setGroupList(grouplist, setGroupListItems, accordionDefaultOpen, pdpItemUpsizeId);
    setSelectedValue([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(grouplist), catalog, isItemAdded]);

  useEffect(() => {
    if (getAndCheck(currentAccordian, source === PDP)) {
      const grpList = grouplist?.length ? JSON.parse(JSON.stringify(grouplist)) : [];
      let mockGroupList = grpList.map((grpitem, idx) => {
        if (grpitem.id === currentAccordian) {
          const offset = grpitem.modifiers?.length > 1 ? 300 : 0;
          let scrollDiv = document.getElementById('accordion-' + currentAccordian).offsetTop;
          window.scrollTo({ top: scrollDiv - offset, behavior: 'smooth' });
          grpitem.expanded = true;
        } else {
          grpitem.expanded = false;
        }
        return grpitem;
      });
      setGroupListItems([...mockGroupList]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAccordian, JSON.stringify(grouplist)]);

  const showSelectedModifier = dataArr => {
    let jsonObject, uniqueSet, uniqueArray;
    if (dataArr.length) {
      jsonObject = dataArr.map(JSON.stringify);
      uniqueSet = new Set(jsonObject);
      uniqueArray = Array.from(uniqueSet).map(JSON.parse);
      let resultArr = [];
      if (selectedValue.length) {
        resultArr = selectedValue;
        let idToSplice = selectedValue.findIndex(sel => sel[0].modgrpId === uniqueArray[0].modgrpId);
        if (idToSplice >= 0) {
          resultArr.splice(idToSplice, 1, uniqueArray);
          setSelectedValue([...resultArr]);
        } else {
          setSelectedValue([...resultArr, uniqueArray]);
        }
      } else {
        setSelectedValue(oldValue => [...oldValue, uniqueArray]);
      }
    }
  };

  useEffect(() => {
    selectedValue.length && getSelectedModifiers(selectedValue);
    selectedModifiers && selectedModifiers(selectedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue]);

  const getSelectedModifierLabel = id => {
    let headerTxt = '';
    let modGrps = pdpPayloadData?.modGrps;
    if (modGrps[id]) {
      let modifiers = modGrps[id]?.modifiers;
      let arr = [];
      for (let mod in modifiers) {
        let item = modifiers[mod];
        if (item.isSelected) {
          let val = deltaPriceInAccordion
            ? getSubHeaderDataL2(
                pdpPayloadData,
                `${id}${HASH_SYMBOL}${item.id}`,
                currencyConversionFactor,
                currencySymbol,
              )
            : false;
          arr.push(`${item.dname?.[0]?.value} ${val !== false ? val : ''}`);
        }
      }
      headerTxt = [...new Set(arr)].reverse().join(', ');
    }
    return headerTxt;
  };

  return (
    getLength(groupListItems) &&
    groupListItems.map(({ id, name, dname, modifiers, expanded, min, max, additionalProperties }, ind) => {
      const isUpdated = checkIfAnyModifierEdited(id, pdpPayloadData);
      const isAnyExcluded = checkExcludedModGItem(id, pdpPayloadData);
      const toShowRecipeSuffixtext = toShowRecipeSuffix(modifiers, localized, max, additionalProperties);
      const toShowMaxBadgeText = !toShowRecipeSuffixtext && toShowMaxTag(showMaxBadge, localized, additionalProperties);
      return (
        <React.Fragment key={ind}>
          <div
            className={`accordian-container ${!expanded && isAnyExcluded ? 'accordian-container-highlight' : ''}`}
            id={'accordion-' + id}
            data-testid={`product-listing-accordion-${ind}`}
          >
            <div className='accordian-header'>
              <div
                className={`${expanded ? 'accordion active' : 'accordion'}`}
                data-testid={`toggle-accordion-${id}`}
                onClick={event => toggleAccordion(groupListItems, event, id, setGroupListItems, preventFeature)}
              >
                <div className='textbadgecontainer'>
                  <h3 className='accordion-test'>{dname?.[0]?.value}</h3>
                  <div className='badgeContainer'>
                    {toShowMaxBadgeText && (
                      <span className='ml-2 maxBadge'>{`${translateWithI18Next(MAX_TAG)} ${max}`}</span>
                    )}
                    {isUpdated ? (
                      <span className='updatedBadge-sopac'>{translateWithI18Next(UPDATED_TEXT)}</span>
                    ) : null}
                  </div>
                </div>
              </div>
              <span className='selected-mod'>{getSelectedModifierLabel(id)}</span>
            </div>
            <div className={`${expanded ? 'panel panel-active' : 'panel'}`}>
              <ProductCustomizeToppingComp
                tenantData={tenantReducer}
                modifiers={modifiers}
                modgrpData={{
                  modgrpId: id,
                  modGrpName: dname,
                  min,
                  max,
                  additionalProperties,
                  modifierLength: modifiers.length,
                }}
                modgroupPayloadData={showSelectedModifier}
                isModal={isModal}
                isStoreClosed={isStoreClosed}
                catalog={catalog}
              />
            </div>
          </div>
        </React.Fragment>
      );
    })
  );
};

export default CustomizationAccordionComp;
